import {
    AppFeaturesToggleEnum,
    CartWebViewBridge,
    CartWebViewBridgeListenEvents,
    CartWebViewBridgeEnum,
    MobileDeviceType,
    WebViewQuickShareParameters,
} from 'core/type/BootstrapConfig.types';
import { getWebkit, getActivitiesInterface } from 'core/window/windowService';

export const checkIsHookFunctionExist = (mobileDeviceType: MobileDeviceType, hookFunctionName: keyof CartWebViewBridge) => {
    switch (mobileDeviceType) {
        case MobileDeviceType.iOS:
            return !!getWebkit()?.messageHandlers?.[hookFunctionName];
        case MobileDeviceType.Android:
            return !!getActivitiesInterface()?.[hookFunctionName];
        default:
            return false;
    }
};

export const callNativeAppFunction = async (name: keyof CartWebViewBridgeListenEvents, input = '') => {
    const activitiesInterface = getActivitiesInterface();
    const messageHandlers = getWebkit()?.messageHandlers;

    if (activitiesInterface) {
        if (input) {
            return activitiesInterface?.[name]?.(input);
        }

        return activitiesInterface?.[name]?.();
    }

    return messageHandlers?.[name]?.postMessage?.(input);
};

export const convertFeaturesListToArray = (featuresListString?: string): string[] => {
    if (!featuresListString) return [];

    try {
        return JSON.parse(featuresListString) as AppFeaturesToggleEnum[];
    } catch (e) {
        return [];
    }
};

export const getApp = () => {
    const activitiesInterface = getActivitiesInterface();
    const messageHandlers = getWebkit()?.messageHandlers;

    return {
        openCartBFWebView: (url: string) => {
            if (activitiesInterface) {
                activitiesInterface?.openCartBFWebView?.(url);
            } else {
                messageHandlers?.openCartBFWebView?.postMessage(url);
            }
        },
        openCartPage: () => {
            if (activitiesInterface) {
                activitiesInterface?.openCartPage?.();
            } else {
                messageHandlers?.openCartPage?.postMessage('');
            }
        },
        openShareSheet: (params: WebViewQuickShareParameters) => {
            if (activitiesInterface) {
                activitiesInterface?.openShareSheet?.(params);
            } else {
                messageHandlers?.openShareSheet?.postMessage(params);
            }
        },
        openPrevNavStack: () => {
            if (activitiesInterface) {
                activitiesInterface?.openPrevNavStack?.();
            } else {
                messageHandlers?.openPrevNavStack?.postMessage('');
            }
        },
        getFeatureToggles: async (): Promise<string[]> => {
            const featureToggles = await callNativeAppFunction(CartWebViewBridgeEnum.getFeatureToggles);
            return convertFeaturesListToArray(featureToggles);
        },
    };
};
